import React from 'react'

/* eslint-disable  @typescript-eslint/no-explicit-any */
function TableRowDeclarationType({ value }: any) {
  switch (value) {
    case 'T1':
      return <span>T1</span>
    case 'T2':
      return <span className="text-warning">T2</span>
    case 'ENS':
      return <span className="text-info">ENS</span>
    default:
      return null
  }
}
export default TableRowDeclarationType
